import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import ClickAwayListener from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ClickAwayListener';
import Popper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Popper';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import EmptyResults from './EmptyResults';
import {
  getFirstSelectableId,
  onCloseResults,
  useSearchBarDispatch,
  useSearchBarState,
} from '../SearchBarContext';
import ResultList from './ResultList';
import SuggestedFilters from './SuggestedFilters';

const styles = (theme) => ({
  root: {
    width: 800,
    borderRadius: theme.radius.sm,
  },
  content: {
    padding: theme.spacing(1.5, 1),
  },
});

const ResultsPopper = ({
  className,
  classes,
  searchInputRef,
}) => {
  const searchBarState = useSearchBarState();
  const searchBarDispatch = useSearchBarDispatch();
  const eventTracking = useEventTrackingLogEvent();
  const { searchResultsOpen, initialized, selectionDOMId } = searchBarState;

  if (!initialized) {
    return null;
  }

  let selectedDOMId = selectionDOMId;
  if (selectionDOMId === null) {
    selectedDOMId = getFirstSelectableId(searchBarState);
  }

  return (
    <Popper
      open={searchResultsOpen}
      anchorEl={searchInputRef.current}
    >
      <ClickAwayListener onClickAway={onCloseResults(searchBarDispatch, searchBarState, eventTracking, searchInputRef)}>
        <Paper
          className={classNames(classes.root, className)}
          elevation={3}
        >
          <div className={classes.content}>
            <SuggestedFilters
              selectedDOMId={selectedDOMId}
            />
            <ResultList
              selectedDOMId={selectedDOMId}
            />
            <EmptyResults />
          </div>
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

ResultsPopper.defaultProps = {
  className: '',
};

ResultsPopper.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  searchInputRef: PropTypes.object.isRequired,
};

export default withStyles(styles)(ResultsPopper);
